import styled, { css } from 'styled-components';
import { breakpoint } from '../../constants/breakpoints';
const bgColor = '#DFE5ED';

export const SkeletonContainer = styled.div`
    width: auto;
    min-width: 100%;
    background: ${({ background }) =>
        background ? background : 'transparent'};
    overflow: ${({ overflow }) => (overflow ? overflow : 'hidden')};
    position: relative;
    margin: ${({ margin }) => (margin ? margin : '0 0 20px')};
    padding: ${({ padding }) => (padding ? padding : '20px 0')};
    box-sizing: border-box;
    * {
        box-sizing: border-box;
    }

    ${({ isMobile }) =>
        isMobile &&
        css`
            padding: ${({ padding }) => (padding ? padding : '20px 16px')};
        `};
`;

export const SkeletonList = styled.div`
    height: auto;
    width: auto;
    display: flex;
    gap: ${({ gap }) => (gap ? gap : '8px')};
    min-width: 100%;
    position: relative;
    ${({ padding }) => (padding ? padding : '20px 16px')};
`;

export const RowSkeletonList = styled(SkeletonList)`
    flex-direction: column;
    gap: 0;
    min-width: 100%;
    width: 100%;
    border-radius: 0 0 4px 4px;
    overflow: hidden;
`;
export const RowLinesSkeletonList = styled(SkeletonList)`
    flex-direction: column;
    gap: ${({ gap }) => (gap ? gap : '8px')};
    width: 100%;
`;

export const SkeletonCard = styled.div`
    height: auto;
    display: flex;
    flex-direction: column;
    width: ${({ width }) => (width ? width : '240px')};
    min-width: ${({ width }) => (width ? width : '240px')};
    padding: ${({ padding }) => (padding ? padding : '16px')};
    border-radius: ${({ radius }) => (radius ? radius : '4px')};
    box-sizing: border-box;
    background: #ffffff;
    position: relative;
`;

export const RowSkeletonCard = styled(SkeletonCard)`
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    min-width: 100%;
    padding: 12px 62px 12px 16px;
    border-radius: 0;

    &:nth-child(even) {
        background: #f0f4fa;
    }

    @media screen and ${breakpoint.M} {
        height: 82px;
        padding: 8px;
    }
`;

export const SkeletonCardItem = styled.div`
    height: auto;
    width: ${({ width }) => (width ? width : '100%')};
    display: flex;
    margin: ${({ margin }) => (margin ? margin : '0 ')};
    padding: ${({ padding }) => (padding ? padding : '0')};
    align-items: flex-start;
    justify-content: flex-start;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
`;

export const SkeletonCardTop = styled.div`
    height: auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    box-sizing: border-box;
    position: relative;
`;

export const SkeletonCardTopDescr = styled.div`
    height: auto;
    width: calc(100% - 73px);
    padding-right: 15px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    box-sizing: border-box;
    position: relative;
`;

export const SkeletonCardTopDate = styled.div`
    height: auto;
    width: 73px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    box-sizing: border-box;
    position: relative;
`;

export const SkeletonDot = styled.div`
    display: block;
    box-sizing: border-box;
    width: ${({ size }) => (size ? size : '6px')};
    height: ${({ size }) => (size ? size : '6px')};
    margin: ${({ margin }) => (margin ? margin : '0 12px 0 0')};
    border-radius: 50%;
    background: ${bgColor};
`;

export const SkeletonLine = styled.div`
    height: ${({ height }) => (height ? height : '10px')};
    width: ${({ width }) => (width ? width : '100%')};
    max-width: 100%;
    margin: ${({ margin }) => (margin ? margin : '0 0 8px')};
    border-radius: ${({ radius }) => (radius ? radius : '15px')};
    border: 1px solid
        ${({ borderColor }) => (borderColor ? borderColor : 'transparent')};
    display: block;
    box-sizing: border-box;
    background: ${({ bC }) => (bC ? bC : `${bgColor}`)};
`;

export const SkeletonButtonWrapper = styled.div`
    width: auto;
    height: auto;
    position: ${({ isEventPage }) => (isEventPage ? 'absolute' : 'relative')};
    right: ${({ isEventPage }) => (isEventPage ? '16px' : '0')};
    bottom: ${({ isEventPage }) => (isEventPage ? '16px' : '0')};
`;

export const SkeletonButtonsWrapper = styled.div`
    width: ${({ width }) => (width ? width : '100%')};
    display: flex;
    align-items: flex-start;
    gap: 4px;
`;

export const SkeletonButton = styled.div`
    height: ${({ height }) => (height ? height : '40px')};
    width: ${({ width }) => (width ? width : '100%')};
    display: block;
    box-sizing: border-box;
    margin: ${({ margin }) => (margin ? margin : '16px 0 0')};
    background: ${bgColor};
    border-radius: 4px;
    flex-shrink: ${({ shrink }) => (shrink ? shrink : 'auto')};
`;
export const RowSkeletonLeft = styled.div`
    display: block;
    height: auto;
    width: ${({ width }) => (width ? width : '30%')};
    padding: 6px 0;
    box-sizing: border-box;

    @media screen and ${breakpoint.M} {
        padding: 0 0 6px;
    }
`;
export const RowSkeletonRight = styled(SkeletonButtonsWrapper)`
    width: 70%;
    gap: 4px;
    align-items: center;
    align-self: flex-end;
    max-width: max-content;
`;
export const ImageSkeleton = styled.div`
    display: block;
    width: 100%;
    height: auto;
    background: ${bgColor};
    border-radius: ${({ radius }) => (radius ? radius : '4px 4px 0 0')};
    aspect-ratio: ${({ aspectRatio }) => (aspectRatio ? aspectRatio : '4/2')};
`;
export const CampaignCardSkeleton = styled(SkeletonCard)`
    padding: 0;
    width: 100%;
    box-shadow: 0 0 4px 2px rgba(163, 157, 163, 0.2);
`;

export const CampaignListSkeleton = styled(SkeletonList)`
    flex-direction: ${({ $direction }) => ($direction ? $direction : 'row')};
    gap: 16px;
    padding: 0;
`;

export const SkeletonWrapper = styled.div`
    width: 100%;
    padding-inline: 15px;
    box-sizing: border-box;

    @media screen and ${breakpoint.M} {
        padding: 0;
    }
`;

export const InputSkeleton = styled(SkeletonLine)`
    height: 45px;
    background: #ffffff;
    margin: 0 auto;
    width: ${({ width }) => (width ? width : '72%')};
    border-radius: ${({ radius }) => (radius ? radius : '8px')};
    max-width: 800px;
`;
